import React, { useEffect, useRef, useState } from 'react';
import { Menu, Search, LogOut, UserCircle, Settings as SettingsIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Avatar from './Avatar';
import NotificationsBell from './NotificationsBell';
import { useAuth } from '../hooks/useAuth';
import { ROLE_LABEL } from '../utils/roles';

function Topbar({ onMenu }) {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function onDoc(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  return (
    <header className="app-topbar topbar">
      <button className="menu-btn" onClick={onMenu} aria-label="Open menu"><Menu size={18} /></button>

      <div className="topbar-search hide-mobile">
        <Search size={16} color="var(--slate-400)" />
        <input placeholder="Search orders, packages, users…" />
      </div>

      <div className="spacer" />

      <div className="topbar-actions">
        <NotificationsBell />

        <div className="profile-wrap" ref={ref}>
          <button className="profile-trigger" onClick={() => setOpen((v) => !v)}>
            <Avatar name={user?.name} />
            <div className="profile-info">
              <div className="name">{user?.name || 'User'}</div>
              <div className="role">{ROLE_LABEL[user?.role] || user?.role}</div>
            </div>
          </button>

          {open && (
            <div className="dropdown" role="menu">
              <button className="dropdown-item" onClick={() => { setOpen(false); navigate('/profile'); }}>
                <UserCircle size={16} /> Profile
              </button>
              <button className="dropdown-item" onClick={() => { setOpen(false); navigate('/settings'); }}>
                <SettingsIcon size={16} /> Settings
              </button>
              <div className="dropdown-divider" />
              <button className="dropdown-item danger" onClick={signOut}>
                <LogOut size={16} /> Sign out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Topbar;
